import React from 'react'

const SecurityTab = () => {
    return (
        // {/* x---------------------------------x Security Tab Section x---------------------------------x */ }
        <div className="row">
            <div className="col-sm-12 my-3">
                <div className="row g-3">
                    <div className="col-md-12">
                        <div>
                            <p className="text-dark fs-6 fw-medium   m-0 ">
                                Two-factor Authentication</p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div
                            className="form-check form-switch-lg form-switch d-flex align-items-center">
                            <input className="form-check-input" defaultChecked
                                type="checkbox" role="switch"
                                id="flexSwitchCheckDefault" />
                            <label className="form-check-label ms-4"
                                htmlFor="flexSwitchCheckDefault">I send
                                or receive digita currency</label>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div>
                            <p className="text-muted fs-6 fw-medium  m-0">
                                Change Password</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="current-password"
                            className="form-label text-dark fs-6 fw-normal ">Current
                            Password</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg "
                            id="current-password"
                            placeholder="**** ****" />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="new-password"
                            className="form-label text-dark fs-6 fw-normal ">New
                            Password</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg "
                            id="new-password" placeholder="**** **** " />
                    </div>
                    <div className="col-md-12 my-3">
                        <div className="row">
                            <div className="col-md-2 ms-auto">
                                <button
                                    className="btn btn-primary w-100 rounded-3">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SecurityTab